export {default as FullscreenLoader} from './FullscreenLoader';



// WEBPACK FOOTER //
// ./src/components/FullscreenLoader/index.tsx